import checkout from "./form";

const {
  formField: {
    address,
    email,
    fax,
    firstTime,
    phone,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxpayerName,
    // address2,
    agencyContract,
    district,
    district2,
    province,
    province2,
    taxId1,
    taxId2,
    certificate,
    signer,
    fullName,
    timeSign,
    ariseTimes,
    checkbox1,
    checkbox2,
    checkbox3,
    date,
    address2,
    email2,
    fax2,
    organizationName,
    phone2,
    taxId3,
    taxpayerName2,
  },
} = checkout;

const initialValues = {
  [address.name]: "",
  [address2.name]: "",
  [taxpayerName2.name]: "",
  [certificate.name]: "",
  [email.name]: "",
  [email2.name]: "",
  [fax.name]: "",
  [fax2.name]: "",
  [organizationName.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [checkbox3.name]: false,
  [phone.name]: "",
  [phone2.name]: "",
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxId2.name]: "",
  [taxId3.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [ariseTimes.name]: "",
  [date.name]: "",
  [district.name]: "",
  [district2.name]: "",
  [province.name]: "",
  [province2.name]: "",
};

export default initialValues;
